// global helpers


pyzel.helpers = {

	/**
	 * Read form the array and returns comma separated values
	 *
	 */
	skill_level: function ( levels ){	

		let levels_array = [];

		$.each( levels, ( k, i ) =>{ 
			
			levels_array.push( i.name );

		})

		return levels_array.join(', ');

	},

	/**
	 * Read form the array and returns comma separated values
	 * a more abstract function than the one above
	 * assumes that there is a "name"
	 * 20.03.2017: now accepts a custom key name
	 * 
	 */
	csv: function ( array, key_name ){		

		let output = [];

		$.each( array, ( k, i ) =>{ 					

			if( ! key_name )
				output.push( i.name );
			else				
				output.push( i[key_name] );				

		})

		return output.join(', ');

	},	


	/**
	 * Get the tails, rails and fin setup name
	 *
	 */
	board_features: function( features ){

		//return 'feature name';
		//console.log( id_feature );
		//console.log( array );

		let board_features = [];

	    //$.each( data[0].features, function( key, value ){
	    $.each( features, ( k, i ) => {

	        if( i.name == 'Stock tail' ){
	            board_features['tail'] = i.value;
	        }else if( i.name == 'Stock Rail' ){
	            board_features['rails']  = i.value;
	        }else if( i.name == 'Stock fin setup' ){
	            board_features['fins']  = i.value;
	        }    

        })

        return board_features;   

	},

	/**
	 * Formats yy-mm-dd to dd / mm / yy
	 *
	 */
	format_date: function ( date ){

		let date_array = date.split( '-' );

		return date_array[2]+' / '+date_array[1]+' / '+date_array[0];

	},


	/**
	 * Formats string to web safe name
	 *
	 */
	 safe_name: function ( string ){

	 	if( typeof string != 'string' ){
	 		console.log( string +' is not a string');
	 	}


	 	//console.log( 'safe_name for: '+string );
	 	//return false;
		
		return string.replace(/\s+/g, '-').toLowerCase();		
		//string = string.replace(/\s+/g, '-');
		//return string.toLowerCase();

	},

	/**
	 * Gets the video returns the id and image
	 * for vimeo at the moment
 	 *
	 */
	get_video_details: function( video ){

		console.log( 'get_video_details' );

		//alert( video );

		//var dfd = $.Deferred();

		// can´t create a vimeo app at the moment..

		let video_details = [];

		console.log( video );
		//console.log( 'video.url: '+video.url );

		let url_array = video.url.split('/');

		//console.log( url_array );

		video_details['id'] = url_array[ url_array.length - 1 ];

		// does not work
		
		// user pedro.silva@shaperbuddy.com
		// app get-video-images

		//return $.when(

			$.ajax({

				url: 'https://api.vimeo.com/oauth/authorize/client',
				method: 'post',
				data: {

					grant_type: "client_credentials"

				},
				/*
				headers: {
	    			//"Authorization : basic " + base64( '84fe85942b9796e7be2d33a355b6144fbf728d3a' + ":" + '7CyQ7UktgdyememDwWkv3Jfa/vbNftNEsOP0WVhOG5RG4k/+Z+8xZ3AgU4fV6qPBuLriVsEL9YoblZYgBU8MJrUvVUcxxseVZ+nQtyc2D/8XBE61l09nyDNcTPVkYYyA')
	    			"Authorization : basic " + base64(client_id + ":" + client_secret)
	  			}
	  			*/
	  			beforeSend: function (xhr) {
	    			xhr.setRequestHeader ("Authorization", "Basic " + btoa('84fe85942b9796e7be2d33a355b6144fbf728d3a'+ ":" + '7CyQ7UktgdyememDwWkv3Jfa/vbNftNEsOP0WVhOG5RG4k/+Z+8xZ3AgU4fV6qPBuLriVsEL9YoblZYgBU8MJrUvVUcxxseVZ+nQtyc2D/8XBE61l09nyDNcTPVkYYyA' ));
				},			

			}).done( function( r ){

				console.log( r.access_token );

				let token = r.access_token;

				//return $.when(

					$.ajax({

						url: 'https://api.vimeo.com/videos/'+video_details['id']+'/pictures',
						method: 'get',
						beforeSend: function(xhr){
		            		xhr.setRequestHeader('Authorization', 'bearer '+token+'');
		            	}

					}).done( r => {

						console.log('we got images from vimeo:');
						console.log( r.data[0].sizes[5].link );
						video_details['image'] = r.data[0].sizes[5].link;

						//return video_details;

						//dfd.resolve();

						return video_details;

					})

				//)	

			}).fail( function( r ){

				console.log( r );

			})		
		
		//)
		//return video_details;

		//return dfd.promise();

	},

}